<template>
    <ul class="cl_team_list" :style="{ height }">
        <li
            class="fs14 SysFontM"
            :class="{ active: teamId === item.id, circle_border: shape === 'circle', cl_team: shape !== 'circle' }"
            :style="{ color, '--activeColor': activeColor }"
            v-for="(item, k) in teamList"
            :key="k + 'team'"
            @click="handleChange(item)"
        >{{ item['name' + $lang] || item.name }}</li>
    </ul>
</template>

<script>
/**
 * ComponentName: team list
 * Created Date:2022/4/21
 * Author: Nancy
 * Modify: haogang·du 2022/4/27 | shishuo·zhang 2022/4/28
 * 组件说明：
 * 这组组件是将梯队列表以现有横向展示出来，通过v-modle获取当前选择的梯队id
 * eg:
 *     <cl-team-list v-modle="teamId"></cl-team-list>
 */
export default {
    name: 'cl-team-list',
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        // 组件高度 默认为55px
        height: {
            type: String,
            default: '55px',
        },
        value: {
            type: String,
            default: '',
        },
        // 默认颜色
        color: {
            type: String,
            default: '#81818A',
        },
        // 高亮颜色
        activeColor: {
            type: String,
            default: '#3663E1',
        },
        // 是否是默认梯队
        isDefault: {
            type: Boolean,
            default: true,
        },
        // 默认传进来的列表
        defaultTeamList: {
            type: Array,
            default: () => [],
        },
        // 默认的样式 默认为高亮为带下划线的 传入circle 则高亮为圆角
        shape: {
            type: String,
            default: 'line',
        },
    },
    data () {
        return {
            teamId: this.value || '',
            teamList: [], // 梯队列表
        };
    },

    watch: {
        value (val) {
            this.teamId = val;
        },
        // 监听一下默认的列表，因为获取默认列表会有一个异步的过程
        defaultTeamList: {
            deep: true,
            immediate: true,
            handler (newV) {
                if (newV.length) {
                    this.getTeams();
                }
            },
        },
    },
    computed: {},
    mounted () {
        this.getTeams();
    },
    methods: {
        // 获取梯队列表
        getTeams () {
            if (!this.defaultTeamList.length && this.isDefault) {
                this.$server.getTeamsList().then((res) => {
                    this.teamList = res?.data || [];
                    if (this.teamList.length) {
                        let teamId = localStorage.getItem('teamId');
                        if (teamId) {
                            let hasTeam = this.teamList.find((item) => item.id === teamId); // 梯队是否在梯队列表中
                            if (hasTeam) {
                                this.teamId = teamId;
                            } else {
                                this.teamId = this.teamList[0].id;
                                localStorage.setItem('teamId', this.teamId);
                            }
                        } else {
                            this.teamId = this.teamList[0].id;
                            localStorage.setItem('teamId', this.teamId);
                        }
                    }
                    this.$emit('team-info', this.teamId, this.teamList);
                });
            } else {
                this.teamList = this.defaultTeamList;
                this.$emit('team-info', this.teamId, this.defaultTeamList);
            }
        },
        // 梯队改变时
        handleChange (item) {
            this.teamId = item.id;
            // defaultTeamList 球探集训试训会用到
            if (!this.defaultTeamList.length) {
                localStorage.setItem('teamId', item.id);
            }
            this.$emit('change', item.id);
        },
    },
};
</script>
<style lang="scss" scoped>
.cl_team_list {
    display: flex;
    align-items: center;
    max-width: 80%;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap; // 空白处理，不换行

    &::-webkit-scrollbar {
        display: none;
    }

    .cl_team {
        height: calc(100% - 3px);
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-right: 30px;
        &.active {
            color: var(--activeColor) !important;
            position: relative;
            &::after {
                content: '';
                display: inline-block;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 3px;
                background-color: var(--activeColor);
                border-radius: 5px 5px 0 0;
            }
        }
    }
    .circle_border {
        height: 32px;
        border-radius: 32px;
        margin-right: 16px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        cursor: pointer;
        &.active {
            color: var(--activeColor) !important;
            background: #3663e1;
        }
    }
}
</style>
